import { getEnv } from "../../../../utils/env"
import { assessmentConstants } from "../constants/assessmentConstants"
import { db } from "../../../mp-database"
import {
  initializeAssessment,
  addAssessmentSets,
  fetchDestructured
} from "../../helpers/assessment/assessmentDashboard"
import requestGroupUAUpdate from "../../helpers/assessment/requestGroupUAUpdate"
import processGroupUAUpdate from "../../helpers/assessment/processGroupUAUpdate"
import addExtraData from "../../helpers/assessment/assessmentDashboard/addExtraData"
import transformSets from "../../helpers/assessment/assessmentDashboard/transformSets"
import getScoring from "../../helpers/assessment/assessmentDashboard/getScoring"
import initializeManageEducators from "../../helpers/users/initializeManageEducators"
import {
  initializing,
  initializingError,
  initializingSuccess,
  setDistricts,
  setSchools,
  setEducators,
  setClasses,
  setStudents
} from "../modules/manageEducators"
import { get, filter } from "lodash"
import {
  fetchingGroupUAsSuccess,
  refreshingSuccess,
  refreshingError,
  isRefreshing,
  fetchingNodes,
  fetchingNodesSuccess,
  fetchingNodesError,
  fetchingAllItems,
  fetchingAllItemsSuccess,
  fetchingAllItemsError
} from "../modules/assessment"
import fetchStudentsScoring from "../../helpers/assessment/fetchStudentsScoring"
import axios from "axios"
import parseSnapshot from "../../helpers/parseSnapshot"
import queryString from "query-string"
import { getSchoolYear } from "../../../mp-utils/generic-utils"

export const assessmentActions = {
  getGroupUAs,
  initAssessment,
  setUserAssessment,
  getAssessmentSets,
  initManageEducators,
  fetchUserAssessments,
  refreshGUA,
  getAnswersByItem,
  updateAnswerItem,
  getUserModalStatus,
  setVideoShown,
  checkAfterTestModal,
  getAllNodes,
  getAllItems,
  initUserAssessments,
  updateItemVideo,
  requestGroupUAs,
  assessmentThresholdDataUpdate,
  fetchGUAsByGroupId,
  getAssessmentScoringStatus
}

//TODO: Get rid of this complex logic for fetching userAssessments
// Initializes assessment data
function initAssessment(
  assessmentId,
  studentId,
  user,
  location,
  userAssessmentId,
  userAssessment,
  history,
  callback
) {
  return (dispatch, getState) => {
    const { assessment } = getState()
    const { userAssessments, assessmentSets } = assessment
    const { search } = location
    const stateUpdaters = {
      loading: assessmentInitialize,
      success: assessmentInitializeSuccess,
      setUserAssessments: userAssessmentsInitializeSuccess,
      error: assessmentInitializeError
    }
    // Initialize assessment.
    if (userAssessmentId && !userAssessment) {
      assessmentInitialize()
      db.collection("userAssessments")
        .doc(userAssessmentId)
        .get()
        .then(doc => {
          if (doc.exists) {
            const userAssessmentData = doc.data()
            addExtraData(userAssessmentData)
              .then(uA => assessmentInitializeSuccess(uA))
              .catch(() =>
                assessmentInitializeError("Error getting destructuredSubtests")
              )
          } else {
            assessmentInitializeError("userAssessment on Route Not Found")
          }
        })
        .catch(err => assessmentInitializeError(err))
    } else if (assessmentId) {
      const qs = queryString.parse(search)
      const year = qs.year ? qs.year : getSchoolYear().year
      const key = `${assessmentId}_${studentId}_${year}`

      initializeAssessment(
        assessmentId,
        studentId,
        user,
        search,
        stateUpdaters,
        assessmentSets
      )

      // if (userAssessments[key]) {
      //   assessmentInitializeSuccess(userAssessments[key])
      // } else {
      //   initializeAssessment(
      //     assessmentId,
      //     studentId,
      //     user,
      //     search,
      //     stateUpdaters,
      //     assessmentSets
      //   )
      // }
    }
    function assessmentInitialize() {
      dispatch({
        type: assessmentConstants.A_ASSESSMENT_INITIALIZE
      })
    }

    function assessmentInitializeSuccess(userAssessment, student) {
      localStorage.setItem("userAssessment", JSON.stringify(userAssessment))
      dispatch({
        type: assessmentConstants.A_ASSESSMENT_INITIALIZE_SUCCESS,
        userAssessment
      })
      if (student && user.role === "Student") {
        dispatch({
          type: "UPDATE_STUDENT_ASSESSMENT_RECORD",
          student
        })
      } else if (student && user.role !== "Student") {
        dispatch({
          type: "UPDATE_STUDENT_ASSESSMENT_RECORD_GUA",
          student
        })
      }

      if (callback) {
        callback(null, userAssessment, student)
      }
    }

    function userAssessmentsInitializeSuccess(userAssessments) {
      dispatch({
        type: assessmentConstants.A_USER_ASSESSMENTS_INITIALIZE_SUCCESS,
        userAssessments
      })
    }

    function assessmentInitializeError(error) {
      console.log("error", error)
      dispatch({
        type: assessmentConstants.A_ASSESSMENT_INITIALIZE_ERROR,
        error
      })

      if (callback) {
        callback(error)
      }
    }
  }
}

function setUserAssessment(userAssessmentId, assessmentId) {
  return (dispatch, getState) => {
    const { assessment, users } = getState()
    const { userAssessments, selectedStudent, isCompare, isSwap } = assessment
    const userAssessment = userAssessments[userAssessmentId]
    if (!userAssessment && assessmentId) {
      const user = users.testUser
      initAssessment(assessmentId, selectedStudent, user, { search: "" })
    } else {
      if (isCompare && isSwap) {
        dispatch({
          type: "SET_COMPARE_ASSISMENT_DATA",
          value: userAssessment
        })
      } else {
        dispatch({
          type: assessmentConstants.A_ASSESSMENT_INITIALIZE_SUCCESS,
          userAssessment
        })
      }
    }
  }
}

function initUserAssessments(
  students,
  items,
  assessmentSets,
  assessmentId,
  year,
  compareAssessmentId,
  compareGuaYear
) {
  return dispatch => {
    userAssessmentsInitialize()
    fetchStudentsScoring(
      students,
      items,
      assessmentSets,
      assessmentId,
      year,
      compareAssessmentId,
      compareGuaYear
    )
      .then(result => {
        userAssessmentsInitializeSuccess(transformResult(result))
      })
      .catch(err => {
        console.log("err", err)
        userAssessmentsInitializeError(err)
      })

    function transformResult(result) {
      const [studentScoring] = result
      let uAs = {}
      let assessmentSet = null
      let assessmentSubtests = null
      let destructuredSubtests = null
      if (assessmentSets[assessmentId]) {
        assessmentSet = assessmentSets[assessmentId].assessmentSet
        assessmentSubtests = assessmentSets[assessmentId].assessmentSubtests
        destructuredSubtests = assessmentSets[assessmentId].destructuredSubtests
      }
      if (studentScoring && Object.keys(studentScoring).length) {
        students.forEach((student, key) => {
          let studentAssesmentId = null
          if (
            student.assessments &&
            student.assessments[assessmentId] &&
            student.assessments[assessmentId][year]
          ) {
            studentAssesmentId =
              student.assessments[assessmentId][year].userAssessmentId
          }
          if (studentAssesmentId) {
            let studentScore =
              studentScoring[`${student.id}_${studentAssesmentId}`] || {}
            uAs[studentAssesmentId] = {
              year: year,
              assessmentSet: assessmentSet,
              assessmentSubtests: assessmentSubtests,
              destructuredSubtests: destructuredSubtests,
              ...studentScore,
              ...student
            }
          }
        })
      }
      return uAs
    }
    function userAssessmentsInitialize() {
      dispatch({
        type: assessmentConstants.A_USER_ASSESSMENTS_INITIALIZE
      })
    }

    function userAssessmentsInitializeSuccess(userAssessments) {
      dispatch({
        type: assessmentConstants.A_USER_ASSESSMENTS_INITIALIZE_SUCCESS,
        userAssessments
      })
    }

    function userAssessmentsInitializeError(error) {
      dispatch({
        type: assessmentConstants.A_USER_ASSESSMENTS_INITIALIZE_ERROR,
        error
      })
    }
  }
}

/**
 * Fetches all userAssessments for selected student in dataDashboard
 * @param {String} studentId
 * @param {Array} assessmentIds
 */
function fetchUserAssessments(studentId, assessmentIds) {
  return dispatch => {
    let userAssessmentPromises = []
    fetchingUserAssessments()

    assessmentIds.forEach(assessment =>
      userAssessmentPromises.push(
        db
          .collection("userAssessments")
          .where("userId", "==", studentId)
          .where("assessmentSetId", "==", assessment)
          .get()
      )
    )
    let extraDataPromises = []
    Promise.all(userAssessmentPromises)
      .then(response => {
        let userAssessments = {}
        response.forEach(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (doc.exists) {
              let data = doc.data()
              if (!data.deleted) {
                userAssessments[data.userAssessmentId] = { ...data }
                extraDataPromises.push(
                  (async id => {
                    const abc = await getScoring(
                      data.userAssessmentId,
                      data.userId
                    )
                    return { scoring: abc, id }
                  })(data.userAssessmentId)
                )
              }
            }
          })
        })
        Promise.all(extraDataPromises).then(scoring => {
          scoring.forEach(score => {
            if (userAssessments && userAssessments[score.id]) {
              userAssessments[score.id].scoring = score.scoring
            }
          })
          fetchingUserAssessmentsSuccess({ studentId, userAssessments })
        })
      })
      .catch(err => fetchingUserAssessmentsError(err))

    function fetchingUserAssessments() {
      dispatch({
        type: assessmentConstants.FETCH_STUDENT_UAS_REQUEST
      })
    }

    function fetchingUserAssessmentsSuccess({ studentId, userAssessments }) {
      dispatch({
        type: assessmentConstants.FETCH_STUDENT_UAS_SUCCESS,
        userAssessments,
        studentId
      })
    }

    function fetchingUserAssessmentsError(error) {
      dispatch({
        type: assessmentConstants.FETCH_STUDENT_UAS_FAILURE,
        error
      })
    }
  }
}

// gets realtime answers
function getAnswersByItem(userAssessmentId, subTestSetId) {
  return dispatch => {
    dispatch(fetchingAnswers())
    const unsubscribe = db
      .collection("answersByItem")
      .doc(`${userAssessmentId}_${subTestSetId}`)
      .onSnapshot(
        doc => {
          if (doc.exists) {
            const data = doc.data()
            const aByItem = {}

            aByItem[subTestSetId] = doc.data().answers

            if (data.gridInputs) {
              aByItem[subTestSetId] = {
                ...aByItem[subTestSetId],
                gridInputs: data.gridInputs
              }
            }

            if (data.responseVectors) {
              aByItem[subTestSetId] = {
                ...aByItem[subTestSetId],
                responseVectors: data.responseVectors
              }
            }

            if (data.thetas) {
              aByItem[subTestSetId] = {
                ...aByItem[subTestSetId],
                thetas: data.thetas
              }
            }

            dispatch(fetchingAnswersSuccess(aByItem))
          } else {
            dispatch(fetchingAnswersSuccess({}))
          }
        },
        err => dispatch(fetchingAnswersError(err))
      )
    return unsubscribe
  }
  function fetchingAnswers() {
    return { type: assessmentConstants.A_FETCHING_ANSWERS }
  }
  function fetchingAnswersSuccess(answers) {
    return {
      type: assessmentConstants.A_FETCHING_ANSWERS_SUCCESS,
      answers
    }
  }
  function fetchingAnswersError(error) {
    return {
      type: assessmentConstants.A_FETCHING_ANSWERS_ERROR,
      error
    }
  }
}

function updateAnswerItem(
  userAssessmentId,
  subTestSetId,
  itemNumber,
  response,
  isCorrect
) {
  return dispatch => {
    // TODO Why is the state key JUST the subtest ID and not the full answersByItem doc id?
    const answersByItemId = subTestSetId //`${userAssessmentId}_${subTestSetId}`
    dispatch({
      type: assessmentConstants.UPDATE_ANSWER_ITEM,
      answersByItemId,
      itemNumber,
      response,
      isCorrect
    })
  }
}

// Gets groupUAs information if needed. groupUA aggregates
// the individual userAssessment data into groups (such as
// all the students who belong to a class or a school).
function getGroupUAs(user, unSubscribe) {
  return dispatch => {
    // super admin might eventually have performance issues. Might need to change to get()
    // If Super Administrator, get all of the groupUAs.
    if (user.role !== "Super Administrator") {
      // If not Super Administrator, query db based on role.
      let query
      if (user.role === "District Admin") {
        query = { key: "district", term: user.schoolDistrict }
      } else if (user.role === "School Admin") {
        query = { key: "school", term: user.school }
      } else if (user.role === "Teacher") {
        query = { key: "teacher", term: user.id }
      }
      dispatch(fetchingGroupUAs())
      const gUAcall = db
        .collection("groupUAs")
        .where(query.key, "==", query.term)
        .onSnapshot(
          querySnapshot => {
            let groupUAs = {}
            querySnapshot.forEach(doc => {
              const gUA = doc.data()
              if (!gUA.deleted) {
                groupUAs[doc.id] = gUA
              }
            })
            dispatch(fetchingGroupUAsSuccess(groupUAs))
          },
          function (err) {
            dispatch(fetchingGroupUAsError(err))
          }
        )
      if (unSubscribe) {
        unSubscribe(gUAcall)
      }
    }
  }

  function fetchingGroupUAs() {
    return { type: assessmentConstants.A_FETCHING_GROUP_UAS }
  }
  function fetchingGroupUAsSuccess(groupUAs) {
    return { type: assessmentConstants.A_FETCHING_GROUP_UAS_SUCCESS, groupUAs }
  }
  function fetchingGroupUAsError(error) {
    return { type: assessmentConstants.A_FETCHING_GROUP_UAS_ERROR, error }
  }
}

/**
 *  requests group UAs for specific groupId, it fetches all entries in
 * gua colection that contains this groupId, it includes documents with
 * all assessments and years
 * @param {*} user
 * @param {*} groupId
 */
function requestGroupUAs(user, groupId) {
  return dispatch => {
    dispatch(ddRefreshGUAs())
    if (user.role === "Super Administrator") {
      db.collection("groupUAs")
        .where("groupId", "==", groupId)
        .get()
        .then(querySnapshot => {
          let groupUAs = {}
          querySnapshot.forEach(doc => {
            groupUAs[doc.id] = doc.data()
          })
          dispatch(ddRefreshGUAsSuccess(groupUAs))
        })
        .catch(err => dispatch(ddRefreshGUAsError(err)))
    } else {
      // If not Super Administrator, query db based on role.
      let query
      if (user.role === "District Admin") {
        query = { key: "district", term: user.schoolDistrict }
      } else if (user.role === "School Admin") {
        query = { key: "school", term: user.school }
      } else if (user.role === "Teacher") {
        query = { key: "teacher", term: user.id }
      }
      db.collection("groupUAs")
        .where(query.key, "==", query.term)
        .where("groupId", "==", groupId)
        .get()
        .then(querySnapshot => {
          let groupUAs = {}
          querySnapshot.forEach(doc => {
            groupUAs[doc.id] = doc.data()
          })
          dispatch(ddRefreshGUAsSuccess(groupUAs))
        })
        .catch(err => dispatch(ddRefreshGUAsError(err)))
    }
  }

  function ddRefreshGUAs() {
    return {
      type: assessmentConstants.DD_REFRESH_GUA
    }
  }

  function ddRefreshGUAsSuccess(groupUAs) {
    return {
      type: assessmentConstants.DD_REFRESH_GUA_SUCCESS,
      groupUAs
    }
  }

  function ddRefreshGUAsError(error) {
    return {
      type: assessmentConstants.DD_REFRESH_GUA_ERROR,
      error
    }
  }
}

function getAssessmentSets(licenses, role) {
  return async dispatch => {
    if (role === "Super Administrator") {
      await db
        .collection("sets")
        .where("licensable", "==", true)
        .get()
        .then(querySnapshot => {
          let possibleLicenses = []
          querySnapshot.forEach(doc => {
            if (doc.exists) possibleLicenses.push(doc.data())
          })
          licenses = possibleLicenses
        })
        .catch(error => dispatch(fetchingSetsError(error)))
    }
    if (licenses && licenses.length === 0) return
    dispatch(fetchingSets())
    try {
      let assessmentSets = []
      let destructuredSubtests = []
      let setsObj = {}

      filter(licenses, { navCategory: "TruScore Testing" }).forEach(license => {
        assessmentSets.push(
          addAssessmentSets(
            license.licenseSet ? license.licenseSet : license.id
          )
        )
      })
      Promise.all(assessmentSets)
        .then(sets => {
          sets.forEach(set => {
            const { assessmentSet, assessmentSubtests } = set
            if (assessmentSet && assessmentSubtests) {
              setsObj[assessmentSet.id] = {
                assessmentSet,
                assessmentSubtests
              }
              destructuredSubtests.push(fetchDestructured(assessmentSubtests))
            }
          })

          return Promise.all(destructuredSubtests)
        })
        .then(destSubtest => {
          let i = 0
          for (let key in setsObj) {
            setsObj[key]["destructuredSubtests"] = destSubtest[i]
            i++
          }

          //transform sets object if there are any SAT or PSAT sets
          setsObj = transformSets(setsObj)
          dispatch(fetchingSetsSuccess(setsObj))
        })
    } catch (err) {
      dispatch(fetchingSetsError(err))
    }
  }

  function fetchingSets() {
    return { type: assessmentConstants.GET_ASSESSMENT_SETS }
  }
  function fetchingSetsSuccess(assessmentSets) {
    return {
      type: assessmentConstants.GET_ASSESSMENT_SETS_SUCCESS,
      assessmentSets
    }
  }
  function fetchingSetsError(error) {
    return { type: assessmentConstants.GET_ASSESSMENT_SETS_FAILED, error }
  }
}

function checkAfterTestModal() {
  return (dispatch, getState) => {
    const {
      users: { testUser },
      assessment: {
        userAssessment,
        modalStatus: {
          is_first_video_show,
          is_afterTest_video_show,
          afterTest,
          tutorialUrl,
          items
        }
      }
    } = getState()

    if (!userAssessment) return
    // Determine student comes first time on dashboard

    if (
      testUser.role === "Student" &&
      userAssessment &&
      !is_afterTest_video_show &&
      !afterTest
    ) {
      let completedTest = 0
      if (get(userAssessment, `scoring.bySubtest`, false)) {
        Object.keys(userAssessment.scoring.bySubtest).forEach(function (key) {
          if (userAssessment.scoring.bySubtest[key].complete) {
            if (completedTest > 1) {
              return
            }
            completedTest = completedTest + 1
          }
        })
      }
      if (completedTest === 1) {
        setTimeout(() => {
          db.collection("userVideoTurorial")
            .doc(testUser.id)
            .get()
            .then(doc => {
              const data = doc.data()
              if (data !== undefined) {
                db.collection("userVideoTurorial").doc(testUser.id).set({
                  is_first_video_show: true,
                  is_afterTest_video_show: true
                })
              }
            })

            .catch(err => dispatch(failure(err)))
        }, 1000)
        dispatch(
          success({
            ...items,
            is_first_video_show: true,
            is_afterTest_video_show: true,
            afterTest: true,
            tutorialUrl: "https://masteryprep.wistia.com/medias/beu90oteov"
          })
        )
      }
    } else {
      dispatch(
        success({
          is_first_video_show,
          is_afterTest_video_show,
          afterTest: false,
          tutorialUrl: "https://masteryprep.wistia.com/medias/9296g3fenj"
        })
      )
    }
  }
  function request() {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_REQUEST }
  }
  function success(status) {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_SUCCESS, status }
  }
  function failure(err) {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_FAILURE, err }
  }
}

function updateItemVideo(subtestSetId, assessmentId, item) {
  return (dispatch, getState) => {
    dispatch(request())
    const {
      users: { testUser },
      assessment: {
        modalStatus: { items }
      }
    } = getState()
    let assessmentItems = get(items, [assessmentId], {})
    let subsetItems = get(assessmentItems, [subtestSetId], {})
    if (testUser) {
      db.collection("userVideoTurorial")
        .doc(testUser.id)
        .update({
          items: {
            ...items,
            [assessmentId]: {
              ...assessmentItems,
              [subtestSetId]: {
                ...subsetItems,
                [item]: true
              }
            }
          }
        })
        .then(() => {
          dispatch(
            success({
              items: {
                ...items,
                [assessmentId]: {
                  ...assessmentItems,
                  [subtestSetId]: {
                    ...subsetItems,
                    [item]: true
                  }
                }
              }
            })
          )
        })
        .catch(err => dispatch(failure(err)))
    }
  }
  function request() {
    return { type: assessmentConstants.UPDATE_TEST_VIDEO_STATUS_REQUEST }
  }
  function success(status) {
    return {
      type: assessmentConstants.UPDATE_TEST_VIDEO_STATUS_SUCCESS,
      status
    }
  }
  function failure(err) {
    return { type: assessmentConstants.UPDATE_TEST_VIDEO_STATUS_FAILURE, err }
  }
}

function setVideoShown() {
  return dispatch => {
    dispatch(request())
    dispatch(
      success({
        is_first_video_show: true
      })
    )
  }

  function request() {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_REQUEST }
  }
  function success(status) {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_SUCCESS, status }
  }
  function failure(err) {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_FAILURE, err }
  }
}

function getUserModalStatus() {
  return (dispatch, getState) => {
    dispatch(request())
    const {
      users: { testUser }
    } = getState()
    if (testUser) {
      let is_first_video_show = false
      let is_afterTest_video_show = false
      let afterTest = false
      db.collection("userVideoTurorial")
        .doc(testUser.id)
        .get()
        .then(doc => {
          const data = doc.data()
          if (data !== undefined) {
            is_first_video_show = data.is_first_video_show
            is_afterTest_video_show = data.is_afterTest_video_show
          }
          // figure out what tutorialURL to use
          const tutorialUrls = {
            studentLaunch: "https://masteryprep.wistia.com/medias/9296g3fenj",
            studentAfterFirstTest:
              "https://masteryprep.wistia.com/medias/beu90oteov",
            teacherLaunch: "https://masteryprep.wistia.com/medias/varf5quifz"
          }
          let tutorialUrl
          if (testUser.role !== "Student") {
            tutorialUrl = tutorialUrls.teacherLaunch
          } else if (!is_first_video_show) {
            tutorialUrl = tutorialUrls.studentLaunch
          } else {
            tutorialUrl = tutorialUrls.studentAfterFirstTest
          }
          dispatch(
            success({
              is_first_video_show,
              is_afterTest_video_show,
              afterTest,
              tutorialUrl
            })
          )

          if (
            (!is_first_video_show &&
              !is_afterTest_video_show &&
              testUser.assessments &&
              Object.keys(testUser.assessments).length) ||
            (!is_first_video_show &&
              !is_afterTest_video_show &&
              testUser.role !== "Student")
          ) {
            db.collection("userVideoTurorial").doc(testUser.id).set({
              is_first_video_show: true,
              is_afterTest_video_show: false
            })
          }
        })
        .catch(err => dispatch(failure(err)))
    }
  }
  function request() {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_REQUEST }
  }
  function success(status) {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_SUCCESS, status }
  }
  function failure(err) {
    return { type: assessmentConstants.FETCH_VIDEO_STATUS_FAILURE, err }
  }
}

function initManageEducators(groupId, setUnsubscribe) {
  return (dispatch, getState) => {
    const { users } = getState()
    const user = users.testUser

    const initActions = {
      initializing: () => dispatch(initializing()),
      initializingError: err => dispatch(initializingError(err)),
      initializingSuccess: () => dispatch(initializingSuccess()),
      set: {
        districts: districts => dispatch(setDistricts(districts)),
        schools: schools => dispatch(setSchools(schools)),
        educators: educators => dispatch(setEducators(educators)),
        students: students => dispatch(setStudents(students)),
        classes: classes => dispatch(setClasses(classes))
      }
    }

    initializeManageEducators(user, initActions, groupId, setUnsubscribe)
  }
}

function refreshGUA(assessmentId, selectedGroupUA, year, m_gua) {
  return (dispatch, getState) => {
    if (assessmentId && selectedGroupUA && year) {
      const { assessment } = getState()
      dispatch(isRefreshing())
      return requestGroupUAUpdate(selectedGroupUA, assessmentId, year, m_gua)
        .then(res => {
          const actions = {
            fetchingGroupUAsSuccess: groupUAs =>
              dispatch(fetchingGroupUAsSuccess(groupUAs)),
            refreshingSuccess: () => dispatch(refreshingSuccess()),
            refreshingError: err => dispatch(refreshingError(err))
          }
          processGroupUAUpdate(
            res,
            assessment.groupUAs,
            selectedGroupUA,
            m_gua,
            year,
            assessmentId,
            actions,
            true
          )
        })
        .catch(err => {
          console.log(err)
          dispatch(refreshingError(err))
        })
    }
  }
}

function getAllNodes() {
  return dispatch => {
    dispatch(fetchingNodes())
    db.collection("knowledgeMapNodes")
      .get()
      .then(querySnapshot => {
        let nodes = {}
        querySnapshot.forEach(doc => {
          const data = doc.data()
          if (!data.deleted) {
            nodes[data.id] = data
          }
        })
        dispatch(fetchingNodesSuccess(nodes))
      })
      .catch(err => dispatch(fetchingNodesError(err)))
  }
}

function getAllItems() {
  return dispatch => {
    dispatch(fetchingAllItems())
    db.collection("contentItems")
      .get()
      .then(querySnapshot => {
        let items = {}
        querySnapshot.forEach(doc => {
          const data = doc.data()
          if (!data.deleted) {
            items[data.itemId] = data
          }
        })
        dispatch(fetchingAllItemsSuccess(items))
      })
      .catch(err => dispatch(fetchingAllItemsError(err)))
  }
}

const initFetchSelectedGUA = () => {
  return {
    type: assessmentConstants.FETCH_SELECTED_GROUPUA_DATA
  }
}
const fetchSelectedGUASuccess = groupUAs => {
  return {
    type: assessmentConstants.FETCH_SELECTED_GROUPUA_DATA_SUCCESS,
    groupUAs
  }
}
const fetchSelectedGUAError = error => {
  return {
    type: assessmentConstants.FETCH_SELECTED_GROUPUA_DATA_ERROR,
    error
  }
}

export function fetchGUAsByGroupId(groupId, assessmentId, queryYear, m_gua) {
  return dispatch => {
    dispatch(initFetchSelectedGUA())

    const guaKey = m_gua ? `${m_gua}_${groupId}` : groupId
    db.collection("groupUAs")
      .where("groupId", "==", guaKey)
      .onSnapshot(
        docs => {
          if (!docs.empty) {
            let groupUAs = parseSnapshot(docs)
            dispatch(fetchSelectedGUASuccess(groupUAs))

            if (assessmentId && queryYear) {
              if (!groupUAs[`${guaKey}_${assessmentId}_${queryYear}`]) {
                dispatch(refreshGUA(assessmentId, groupId, queryYear, m_gua))
              }
            }
          } else {
            dispatch(fetchSelectedGUAError("No groupUA found"))
            dispatch(refreshGUA(assessmentId, groupId, queryYear, m_gua))
          }
        },
        error => {
          console.log(error)
          dispatch(fetchSelectedGUAError(error))
        }
      )
  }
}

function assessmentThresholdDataUpdate(groupUAs_NodeName, thresholdModalData) {
  return (dispatch, getState) => {
    dispatch(assessmentThresholdDataUpdateInitialize())
    db.collection("groupUAs")
      .doc(groupUAs_NodeName)
      .update({ ["thresholdFilterData"]: thresholdModalData })
      .then(() => {
        const {
          assessment: { groupUAs }
        } = getState()

        if (groupUAs && groupUAs[groupUAs_NodeName]) {
          const groupUA = {
            ...groupUAs[groupUAs_NodeName],
            thresholdFilterData: thresholdModalData
          }
          groupUAs[groupUAs_NodeName] = groupUA
          dispatch(fetchingGroupUAsSuccess(groupUAs))
        }

        dispatch(assessmentThresholdDataUpdateSuccess())
      })
      .catch(error => {
        console.log(error)
        dispatch(assessmentThresholdDataUpdateError(error.message))
      })
  }
}
function assessmentThresholdDataUpdateInitialize() {
  return {
    type: assessmentConstants.UPDATE_GUA_THRESHOLD_DATA
  }
}
function assessmentThresholdDataUpdateSuccess() {
  return {
    type: assessmentConstants.UPDATE_GUA_THRESHOLD_DATA_SUCCESS
  }
}
function assessmentThresholdDataUpdateError() {
  return {
    type: assessmentConstants.UPDATE_GUA_THRESHOLD_DATA_ERROR
  }
}

export async function fetchAdmins(searchData) {
  const {
    searchField = "school",
    collection = "educators",
    id,
    fetchSuperAdmin = false,
    fetchDistrictAdmins = false,
    whereOptions = []
  } = searchData

  const educators = {}
  const totalEductors = []
  let schoolDistrict = null

  if (id) {
    let query = db.collection(collection).where(searchField, "==", id)

    whereOptions.forEach(([field, operator, value]) => {
      query = query.where(field, operator, value)
    })

    const schooleducators = (await query.get()).docs
    const mapData = schooleducators.map(doc => {
      if (doc.exists) {
        educators[doc.data().id] = doc.data()
        return doc.data()
      }
    })
    if (mapData.length) {
      schoolDistrict = mapData[0].schoolDistrict
    }
    if (schoolDistrict && fetchDistrictAdmins) {
      const getDistrictAdmins = await db
        .collection("educators")
        .where("role", "==", "District Admin")
        .where("id", "==", schoolDistrict)
        .get()
      totalEductors.push(...getDistrictAdmins.docs)
    }
  }
  if (fetchSuperAdmin) {
    const getSuperAdmins = await db
      .collection("educators")
      .where("role", "==", "Super Administrator")
      .get()
    totalEductors.push(...getSuperAdmins.docs)
  }
  totalEductors.map(doc => {
    if (doc.exists) {
      educators[doc.data().id] = doc.data()
      return doc.data()
    }
  })
  return educators
}

function getAssessmentScoringStatus(userAssessmentId) {
  return dispatch => {
    dispatch(fetchingScoringStatus())
    const unsubscribe = db
      .collection("scoringByItem")
      .where("userAssessmentId", "==", userAssessmentId)
      .where("complete", "==", true)
      .onSnapshot(
        async querySnapshot => {
          let subtestScoringStatus = {}

          for (let i = 0; i < querySnapshot.docs.length; i++) {
            const doc = querySnapshot.docs[i]
            const data = doc.data()
            if (!data.deleted) {
              subtestScoringStatus[doc.id] = data

              if (
                data.calculation_status &&
                data.calculation_status === "PROCESSING"
              ) {
                const url = `${getEnv(
                  "CLOUD_FUNCTION_ROOT"
                )}/miscGroup-serverTimestamp`
                const res = await axios.get(url)

                if (res.data.success) {
                  const currentServerTimestamp = res.data.timestamp

                  const diff =
                    currentServerTimestamp._milliseconds -
                    data.calculation_timestamp.toMillis()

                  //15 mins
                  if (diff > 900000) {
                    await db
                      .collection("scoringByItem")
                      .doc(doc.id)
                      .update({ calculation_status: "PENDING" })
                  }
                }
              }
            }
          }
          dispatch(fetchingScoringStatusSuccess(subtestScoringStatus))
        },
        err => dispatch(fetchingScoringStatusError(err))
      )
    return unsubscribe
  }
  function fetchingScoringStatus() {
    return { type: assessmentConstants.A_ASSESSMENT_SCORING_STATUS }
  }
  function fetchingScoringStatusSuccess(subtestScoringStatus) {
    return {
      type: assessmentConstants.A_ASSESSMENT_SCORING_STATUS_SUCCESS,
      subtestScoringStatus
    }
  }
  function fetchingScoringStatusError(error) {
    return {
      type: assessmentConstants.A_ASSESSMENT_SCORING_STATUS_ERROR,
      error
    }
  }
}
